import React from "react";
import { Minus, Plus } from "lucide-react";

export default function NumberStepper({ value, onChange, min = 0, max = 20, label, hint, testId }) {
  const set = (v) => onChange(Math.max(min, Math.min(max, v)));
  return (
    <div className="flex items-center justify-between gap-3 py-3" data-testid={testId}>
      <div className="min-w-0">
        <div className="text-sm font-medium text-stone-800">{label}</div>
        {hint && <div className="text-xs text-stone-400">{hint}</div>}
      </div>
      <div className="flex items-center gap-1 shrink-0">
        <button
          type="button"
          onClick={() => set(value - 1)}
          disabled={value <= min}
          className="w-9 h-9 rounded-lg border border-stone-300 flex items-center justify-center text-stone-700 hover:bg-stone-50 disabled:opacity-30"
          data-testid={`${testId}-minus`}
        >
          <Minus className="w-4 h-4" />
        </button>
        <span className="w-9 text-center font-mono font-bold text-stone-900" data-testid={`${testId}-value`}>{value}</span>
        <button
          type="button"
          onClick={() => set(value + 1)}
          disabled={value >= max}
          className="w-9 h-9 rounded-lg border border-stone-300 flex items-center justify-center text-stone-700 hover:bg-stone-50 disabled:opacity-30"
          data-testid={`${testId}-plus`}
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
